export default __webpack_public_path__ + "static/Toyota Financial Services – Horizontal 800x400-ea7f7f902f0402344d3bcc36484fdda4.svg";